export default {
  "pl": {
    "subscription": {
      "customers": {
        "announcement": {
          "description": "Otrzymuj powiadomienia o publikacji nowych postów.",
          "label": "Posty z aktualnościami"
        },
        "question": {
          "description": "Otrzymuj powiadomienia o dodaniu nowych pytań w sekcji FAQ.",
          "label": "FAQ"
        }
      },
      "employees": {
        "announcement": {
          "description": "Otrzymuj powiadomienia o publikacji nowych postów.",
          "label": "Posty z aktualnościami"
        },
        "decision": {
          "description": "Otrzymuj powiadomienia dotyczące decyzji.",
          "label": "Decyzje"
        },
        "document": {
          "description": "Otrzymuj powiadomienia o przesłaniu nowych dokumentów.",
          "label": "Dokumenty"
        },
        "export": {
          "description": "Otrzymuj powiadomienie, gdy generowane są eksporty.",
          "label": "Eksport"
        },
        "question": {
          "description": "Otrzymuj powiadomienia o dodaniu nowych pytań w sekcji FAQ.",
          "label": "FAQ"
        },
        "survey": {
          "description": "Otrzymuj powiadomienia dotyczące ankiet.",
          "label": "Ankiety"
        },
        "ticket": {
          "description": "Otrzymuj powiadomienia dotyczące rozmów.",
          "label": "Rozmowy"
        },
        "todo": {
          "description": "Otrzymuj powiadomienia, kiedy ktoś wyznaczy cię do zadania.",
          "label": "Przypisane zadania"
        }
      },
      "labels": {
        "email_preferences": "Moje preferencje dotyczące powiadomień e-mail",
        "general_preferences": "Moje preferencje dotyczące powiadomień",
        "receiveEmailNotificationsAbout": "Otrzymuj powiadomienia e-mail"
      }
    }
  }
}
